/*ěščřžýáíéúů*/
(function ($) {
	"use strict";

	// .produkty-new__pagination-bar se po každé AJAX akci celá nahradí čerstvým
	// HTML ze serveru (jinak by "current" stránka v číslování a stav "Načíst
	// další" neodpovídaly realitě) — proto se na kliky uvnitř lišty váže přes
	// delegaci na stabilní rodičovský kontejner, ne na konkrétní elementy.
	var $wrap = $(".produkty-new__results");
	var $grid = $("#produkty-new-grid");

	function getBar() {
		return $wrap.find(".produkty-new__pagination-bar");
	}

	function scrollToGrid() {
		if (!$grid.length) return;
		$("html, body").animate({ scrollTop: $grid.offset().top - 40 }, 400);
	}

	// Po přechodu na jinou stránku číslovaného stránkování (ne "Načíst další") —
	// scroll na úplný začátek stránky, ne na grid (ten by schoval title
	// i výpis kategorií nad ním).
	function scrollToPageTop() {
		$("html, body").animate({ scrollTop: 0 }, 400);
	}

	// DOČASNÝ HACK, dokud je stránka "Produkty - nové" draft — bez pěkného
	// URL vede jen přes "?page_id=", jinak (window.location.pathname) by to
	// při AJAX přenačtení bylo jen "/" a stránka by se ztratila (smazat po
	// publikování stránky — viz produkty_new_preserve_page_id() v PHP).
	function getPageUrl() {
		var base = window.location.origin + window.location.pathname;
		var match = window.location.search.match(/[?&]page_id=(\d+)/);
		return match ? base + "?page_id=" + match[1] : base;
	}

	// Nahradí/přidá "stranka=N" v libovolné URL (zachová zbytek query stringu).
	function withStranka(url, pageNum) {
		var parts = url.split("?");
		var pairs = (parts[1] || "").split("&").filter(function (pair) {
			return pair && pair.indexOf("stranka=") !== 0;
		});
		pairs.push("stranka=" + pageNum);
		return parts[0] + "?" + pairs.join("&");
	}

	// Po AJAX stránkování/"Načíst další" se do adresního řádku propíše
	// "?stranka=N" (přes pushState, bez reloadu) — ať se dá např. z detailu
	// produktu vrátit zpátky přesně na stránku výpisu, na které uživatel byl
	// (viz i SSR čtení "$_GET['stranka']" v produkty-new.php). Odkaz "Vymazat
	// filtry" je vyrenderovaný serverem jen při prvním načtení stránky — bez
	// tohohle by po AJAX stránkování zůstal ukazovat na starou (např. první) stránku.
	function updateUrlStranka(pageNum) {
		history.pushState(
			null,
			"",
			withStranka(window.location.pathname + window.location.search, pageNum),
		);

		var $clear = $(".produkty-new__filters-clear a");
		if ($clear.length) {
			$clear.attr("href", withStranka($clear.attr("href"), pageNum));
		}
	}

	// ── Filtry: na mobilu schovat celý panel za tlačítko "Filtrovat" ──────────

	$(".produkty-new__filters-toggle").on("click", function () {
		$(this)
			.closest(".produkty-new__filters")
			.toggleClass("produkty-new__filters--open");
	});

	// ── Filtry: rozbalit / skrýt "extra" položky ──────────────────────────────

	$(".produkty-new__filter-toggle").on("click", function () {
		var $btn = $(this);
		var $group = $btn.closest(".produkty-new__filter-group");
		var isOpen = $group.hasClass("produkty-new__filter-group--expanded");

		$group.toggleClass("produkty-new__filter-group--expanded", !isOpen);
		// .text() na tlačítko by smazalo i ikonu (btn__icon) vedle textu —
		// měnit jen text span, tlačítko zůstává celé.
		$btn
			.find(".produkty-new__filter-toggle-text")
			.text(isOpen ? $btn.data("show-text") : $btn.data("hide-text"));
	});

	// ── Filtry: posbírat aktuálně zaškrtnuté hodnoty po skupinách ─────────────
	// Čárkou oddělený seznam v jediném parametru na skupinu (odpovídá
	// get_produkty_new_facet_conditions() v PHP) — NE pole (to by jQuery/prohlížeč
	// serializovaly se závorkami, "medium[]=...", což končí jako "medium%5B%5D=..." v URL).

	function getActiveFilters() {
		var filters = {};

		$(".produkty-new__filter-group").each(function () {
			var group = $(this).data("filter-group");
			var values = $(this)
				.find('input[type="checkbox"]:checked')
				.map(function () {
					return this.value;
				})
				.get();

			if (values.length) {
				filters[group] = values.join(",");
			}
		});

		return filters;
	}

	// mode: "append" (Načíst další) nebo "replace" (filtr / klik na stránku)
	function fetchProducts(paged, mode) {
		var $bar = getBar();
		var loadUrl = $bar.data("load-url");
		if (!loadUrl) return;

		var data = $.extend(
			{ stranka: paged, page_url: getPageUrl() },
			getActiveFilters(),
		);

		// Hledaný výraz zadaný přes ?hledani= (viz produkty-new.php) — drží se
		// v data-hledani na .produkty-new__results, ať zůstane aktivní i při
		// dalším filtrování/stránkování přes AJAX.
		var hledani = $wrap.data("hledani");
		if (hledani) {
			data.hledani = hledani;
		}

		if (mode === "append") {
			$bar
				.find(".produkty-new__load-more")
				.addClass("produkty-new__load-more--loading");
		}

		$.ajax({
			url: loadUrl,
			type: "GET",
			dataType: "json",
			data: data,
			error: function (xhr, status, err) {
				console.error("Produkty load error:", status, err);
				$bar
					.find(".produkty-new__load-more")
					.removeClass("produkty-new__load-more--loading");
			},
		}).done(function (res) {
			if (!res) return;

			if (mode === "append") {
				$grid.append(res.cards);
			} else {
				$grid.html(res.cards);
				scrollToPageTop();
			}

			getBar().replaceWith(res.bar);
			updateUrlStranka(paged);
		});
	}

	// ── Filtry + hledání: submit formuláře, ale s ručně poskládanou URL ───────
	// Filtrování i hledání jede přes klasický GET formulář (viz
	// template-parts/produkty-new/filters.php), NE přes AJAX — jen "Načíst
	// další"/stránkování níž zůstává AJAX, uvnitř už načteného výsledku.
	// URL se skládá ručně (ne necháním prohlížeče serializovat formulář), ať:
	// - prázdné "hledani" úplně zmizí z URL (žádné "?hledani=")
	// - víc zaškrtnutých hodnot ve skupině jde jako "medium=a,b", ne "medium[]=a&medium[]=b"

	$(document).on("submit", "#produkty-new-filters-form", function (e) {
		e.preventDefault();

		var $form = $(this);
		var params = [];

		// Hidden inputy uvnitř formuláře (dočasně jen "page_id", viz filters.php).
		$form.find('input[type="hidden"]').each(function () {
			if (this.value !== "") {
				params.push(
					encodeURIComponent(this.name) + "=" + encodeURIComponent(this.value),
				);
			}
		});

		// Vyhledávací input žije jinde v DOM (nadpis-vyhledavani__search) — je jen
		// cross-asociovaný přes form="produkty-new-filters-form" (viz produkty-new.php).
		var $search = $('input[type="text"][form="' + this.id + '"]');
		if ($search.length && $search.val()) {
			params.push("hledani=" + encodeURIComponent($search.val()));
		}

		$.each(getActiveFilters(), function (group, value) {
			// Zvlášť zakódovaná jednotlivá jména, spojená natvrdo čárkou — čárka
			// je v query stringu platný znak, netřeba ji zakódovat na "%2C".
			var encoded = value
				.split(",")
				.map(function (slug) {
					return encodeURIComponent(slug);
				})
				.join(",");
			params.push(group + "=" + encoded);
		});

		// Base bez query stringu — action může sám o sobě už "?page_id=..." nést
		// (dočasný draft hack, viz produkty_new_preserve_page_id() v PHP), a ten
		// se posílá zvlášť přes hidden input výš, jinak by v URL byl 2x.
		var base = $form.attr("action").split("?")[0];
		var url = base + (params.length ? "?" + params.join("&") : "");
		window.location.href = url;
	});

	// Checkbox sám o sobě formulář nesubmituje — .submit() na DOM prvku navíc
	// obchází submit event (a s ním handler výš), proto přes jQuery .trigger().
	$(".produkty-new__filters").on(
		"change",
		'input[type="checkbox"]',
		function () {
			$(this.form).trigger("submit");
		},
	);

	// ── Nahoru: plynulý scroll ke gridu ────────────────────────────────────────

	$(document).on("click", ".produkty-new__scroll-top", function (e) {
		e.preventDefault();
		scrollToGrid();
	});

	// ── Načíst další: AJAX append další strany produktů (respektuje filtry) ──

	$(document).on(
		"click",
		".produkty-new__load-more:not(.produkty-new__load-more--loading)",
		function () {
			var $bar = getBar();
			var paged = parseInt($bar.data("paged"), 10) || 1;
			fetchProducts(paged + 1, "append");

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "product_list_interaction",
				type: "load_more",
			});
		},
	);

	// ── Číslované stránkování: AJAX skok na konkrétní stránku ─────────────────

	$(document).on(
		"click",
		".produkty-new__pagination a.page-numbers",
		function (e) {
			e.preventDefault();
			var href = $(this).attr("href") || "";
			var match = href.match(/[?&]stranka=(\d+)/);
			var pageNum = match ? parseInt(match[1], 10) : 1;
			fetchProducts(pageNum, "replace");
		},
	);
})(jQuery);
